import React, { Fragment, lazy, Suspense } from "react";

import { getCookie } from "src/utils/utils";
import LoadingScreen from "src/components/LoadingScreen";

interface ClientMockProps {
  children: any;
}

const ClientMock: React.FC<ClientMockProps> = ({ children }) => {
  const isMock = getCookie("useMock");

  if (isMock === "true") {
    const MockContent = lazy(() => import("./mock"));
    return (
      <Suspense fallback={<LoadingScreen />}>
        <MockContent>{children}</MockContent>;
      </Suspense>
    );
  }

  return <Fragment>{children}</Fragment>;
};

export default ClientMock;
